import CartDeliveryLocation from "./CartDeliveryLocation";
import CartDeliveryMethod from "./CartDeliveryMethod";
import CartDeliveryDate from "./CartDeliveryDate";
import useBusinessLocations from "../../../../services/state/account/useBusinessLocations";
import useCheckoutStore from "../../../../cart/store/checkoutStore";

const CartDelivery = () => {

    const bpLocations = useBusinessLocations(true);
    const selected  = useCheckoutStore(state => state.input?.locationID);
    const orderLocationID = useCheckoutStore(state => state.order?.C_BPartner_Location_ID?.id);
    const orderLocation = bpLocations.locations?.find(bpl => bpl.id === orderLocationID);



    return (
        <>
            <CartDeliveryLocation
                bpLocations={bpLocations}
                orderLocation={orderLocation}
                selected={selected}
            />
            {selected &&
                <>
                    <CartDeliveryMethod />
                    <CartDeliveryDate />
                </>
            }
        </>
    )
}

export default CartDelivery;
